import React from "react";
import { useForm } from "react-hook-form";
import Form from "../../components/Form";
import InputTags from "../../components/InputTags";
import PropTypes from "prop-types";
import Paper from "../../components/Paper";
import { makeStyles } from "../../utils/styles";
import Typography from "../../components/Typography";
import Divider from "../../components/Divider";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FORM } from "../../utils/constans";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((css) => ({
    paper: css`
        padding: 30px;
        min-height: 100%;
    `,
    dividerHeader: css`
        margin-top: 25px;
        margin-bottom: 25px;
    `,
}));

const schema = yup.object().shape({
    skill: yup.string().required(FORM.FIELD_IS_REQUIRED),
});

const FormSkills = ({ skills, loading, onSubmit, onClickDelete }) => {
    const { t } = useTranslation()
    const { register, handleSubmit, errors, reset } = useForm({
        resolver: yupResolver(schema),
    });
    const styles = useStyles();
    const onSubmitWithReset = onSubmit(reset);
    
    return (
        <Paper
            customStyle={styles.paper}
        >
            <Form onSubmit={handleSubmit(onSubmitWithReset)}>
                <Typography as="h1">
                    {t("Umiejętności")}
                </Typography>
                <Divider
                    customStyle={styles.dividerHeader}
                />
                <InputTags
                    type="text"
                    ref={register}
                    onClickAdd={handleSubmit(onSubmitWithReset)}
                    onClickDelete={onClickDelete}
                    name="skill"
                    placeholder={t("Wpisz umiejętność i naciśnij Enter")}
                    disabled={loading}
                    error={!!errors.skill}
                    errorText={errors.skill?.message}
                    tags={skills}
                    readonly={skills.length <= 1}
                    scrollArea={{
                        heightModifiers: {
                            isCalc: true,
                            offset: 70
                        }
                    }}
                />
            </Form>
        </Paper>
    );
};

FormSkills.propTypes = {
    skills: PropTypes.array,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func,
    onClickDelete: PropTypes.func
};

export default FormSkills;
